import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

import { colors } from "@/theme/overrides/colors";

const NoMealsIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 51 41" {...props}>
      <path
        d="M44.4983 24.1108H5.83437C3.65839 24.1108 1.8877 25.8285 1.8877 27.94C1.8877 30.0512 3.65839 31.7692 5.83437 31.7692H44.4983C46.6746 31.7692 48.445 30.0512 48.445 27.94C48.445 25.8285 46.6746 24.1108 44.4983 24.1108Z"
        fill="#C0C5CD"
      />
      <path
        d="M25.1662 7.06592C16.1319 7.06592 8.55685 13.2375 6.68066 21.4631H43.6518C41.7756 13.2375 34.2005 7.06592 25.1662 7.06592Z"
        fill="#C0C5CD"
      />
      <path
        d="M29.0458 4.8348V3.76404C29.0458 1.68834 27.3053 0 25.1663 0C23.0273 0 21.2871 1.68868 21.2871 3.76404V4.8348C22.5396 4.58047 23.8371 4.44572 25.1663 4.44572C26.4958 4.44572 27.793 4.58047 29.0458 4.8348Z"
        fill="#C0C5CD"
      />
      <path
        d="M1.22266 37.1049L49.1102 2.90381"
        stroke={colors.light}
        strokeWidth="3.32553"
      />
      <path
        d="M1.22266 39.6859L49.1102 5.48486"
        stroke="#C0C5CD"
        strokeWidth="3.32553"
      />
    </SvgIcon>
  );
};

export default NoMealsIcon;
